import {
    AreaProjectSubscriptionProps,
    BatchSubscriptionProps,
    ConstructionNumberSubscriptionProps,
    ProjectPhaseSubscriptionProps,
    PropertyTypeSubscriptionProps,
} from './endpoint-types';
import { subscribeToObject } from './subscribe-base';
import { subscribeToBatchObjects } from './subscribe-batch';

const subscriptionApiCalls = {
    constructionNumber: (props: ConstructionNumberSubscriptionProps) => subscribeToObject(props),
    propertyType: (props: PropertyTypeSubscriptionProps) => subscribeToObject(props),
    projectPhase: (props: ProjectPhaseSubscriptionProps) => subscribeToObject(props),
    areaProject: (props: AreaProjectSubscriptionProps) => subscribeToObject(props),
    batch: (props: BatchSubscriptionProps) => subscribeToBatchObjects(props),
};

export { subscriptionApiCalls };
